module.exports = __webpack_public_path__ + "img/mg.c9dddf98.svg";